/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-05-17T17:56:04.333
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentIssueHouseApply,
	listRentIssueHouseApplyInit,
	listRentIssueHouseApplyByAuthorizations,
	deleteRentIssueHouseApply
	
} from '@api/rentmanage/RentIssueHouseApply';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentIssueHouseApply({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentIssueHouseApply(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentIssueHouseApplyByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentIssueHouseApplyByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentIssueHouseApplyInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentIssueHouseApplyInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentIssueHouseApply({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentIssueHouseApply({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
